export default Symbol('carousel')
